module.exports = __webpack_public_path__ + "static/media/1.91f7ea9a.JPG";